import { defineStore } from 'pinia'
import axios from 'axios'

export const useNewsStore = defineStore('news', {
	state: () => {
		return {
			articles: [],
		}
	},
	getters: {
		//
	},
	actions: {
		setup() {
			this.getArticles()
		},
		getArticles() {
			return axios
				.get('/api/news')
				.then((articles) => {
					this.articles = articles.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
